import axios from "axios";
import authHeader from "services/auth-header";

class ChatSessionService {
  list(type, parameters) {
    let api_path =
      type === "history" ? "chat_sessions/history?" : "chat_sessions?";
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + api_path + parameters, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  show(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + "chat_sessions/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  update(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + "chat_sessions/" + id, params, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getTwilioTokens() {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + "twilio_chat_tokens", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateReadStatus(twilio_id, params) {
    return axios
      .put(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${twilio_id}/update_read_status`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  getChatMedication(id) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${id}/chat_medication`,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  updateChatMedication(id, params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${id}/chat_medication`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  getChatMedicationHistories(id, params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${id}/chat_medication/history`,
        { headers: authHeader(), params: params }
      )
      .then((response) => {
        return response.data;
      });
  }

  getHealthInfoHistories(id, params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${id}/chat_health_info/history`,
        { headers: authHeader(), params: params }
      )
      .then((response) => {
        return response.data;
      });
  }

  getHealthDataSummary(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `health_data_summary`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        return response.data;
      });
  }

  getHealthMetricsTableData(params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `health_data_entries/health_metrics_table`,
        {
          headers: authHeader(),
          params: params
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  createVideoSession(params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `doctors/video_sessions/premium_plus`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  bookVideoSession(params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + `doctors/video_sessions`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  notifyUser(params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + `video_sessions/notifications`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  getNutritionInfo(id) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${id}/nutrition_info`,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  getFoodLogList(id, params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT + `chat_sessions/${id}/food_log`,
        { headers: authHeader(), params: params }
      )
      .then((response) => {
        return response.data;
      });
  }

  getNutritionQuestionnaire(id) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `chat_sessions/${id}/nutrition_questionnaire`,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  getUnreadCounts() {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + "chat_sessions/unread_counts", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  updateIsAiPowered(id, params) {
    return axios
      .put(
        process.env.REACT_APP_API_ENDPOINT +
          "chat_sessions/" +
          id +
          "/update_is_ai_powered",
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  rescheduleVideoSession(params) {
    return axios
      .put(
        process.env.REACT_APP_API_ENDPOINT +
          `doctors/video_sessions/reschedule`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new ChatSessionService();
